var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_has.js
// module id = 115
// module chunks = 2